<template>
  <LayoutDashboard title="Empresa">
    <v-card outlined>
      <v-card-title>
        <v-tabs app grow v-model="tabs" class="hidden-sm-and-down">
          <v-tab>
            <span>GERAL</span>
          </v-tab>

          <v-tab>
            <span>CONFIGURAÇÃO NF-e</span>
          </v-tab>

          <v-tab>
            <span>NATUREZA OPERAÇÃO</span>
          </v-tab>

          <v-tab>
            <span>TRIBUTACÃO</span>
          </v-tab>
        </v-tabs>
      </v-card-title>

      <v-divider></v-divider>
      <v-card-text>
        <v-flex xs12>
          <v-tabs-items v-model="tabs">
            <!-- informações gerais -->
            <v-tab-item>
              <v-layout row wrap>
                <v-flex xs12 md2>
                  <v-row justify="space-around" class="ml-3 mr-3 mb-3">
                    <v-img :src="$urlApp + '/produtos/sem_imagem.jpg'" aspect-ratio="1.4" @click="modalLogo = true" contain v-if="!getEmpresa.url_logo"></v-img>
                    <v-img :src="getEmpresa.url_logo" aspect-ratio="1.4" @click="modalLogo = true" contain v-if="getEmpresa.url_logo"></v-img>
                  </v-row>
                </v-flex>
                <v-flex xs12 md10>
                  <v-layout row wrap class="pa-0 ma-0">
                    <v-flex xs12 md6>
                      <v-text-field dense outlined v-model="getEmpresa.razao_social" label="Razão Social" :rules="rules.obrigatorio" class="ml-3 mr-3 mt-1"> </v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field dense outlined v-model="getEmpresa.nome_fantasia" label="Nome Fantasia" class="ml-3 mr-3 mt-1"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field dense outlined v-model="getEmpresa.cnpj" label="CNPJ" v-mask="'##.###.###/####-##'" class="ml-3 mr-3"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field dense outlined v-model="getEmpresa.ie" label="IE" class="ml-3 mr-3"> </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field dense outlined v-model="getEmpresa.telefone" label="Telefone" v-mask="'(##) ####-####'" class="ml-3 mr-3"></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field dense outlined v-model="getEmpresa.celular1" label="Celuar 1" v-mask="'(##) #####-####'" class="ml-3 mr-3"></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field dense outlined v-model="getEmpresa.celular2" label="Celuar 2" v-mask="'(##) #####-####'" class="ml-3 mr-3"></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field dense outlined v-model="getEmpresa.email" label="E-mail" class="ml-3 mr-3"></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field dense outlined v-model="getEmpresa.cep" @blur="pesquisaCep" label="CEP" v-mask="'#####-###'" class="ml-3 mr-3"></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field dense outlined v-model="getEmpresa.logradouro" label="Logradouro" class="ml-3 mr-3"></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field dense outlined v-model="getEmpresa.numero" label="Número" id="numero" class="ml-3 mr-3"></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field dense outlined v-model="getEmpresa.bairro" label="Bairro" class="ml-3 mr-3"> </v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-autocomplete
                    :items="getCidades"
                    v-model="cidadeSelecionada"
                    label="Cidade"
                    class="ml-3 mr-3"
                    dense
                    outlined
                    item-text="nome"
                    item-value="nome"
                    autocomplete="new-cidade"
                    @click="$event.target.select()"
                    return-object
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field dense outlined v-model="getEmpresa.codigo_municipio" label="Código Munícipio" class="ml-3 mr-3"></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-autocomplete :items="getEstados" v-model="estadoSelecionado" label="Estado" class="ml-3 mr-3" dense outlined item-text="uf" item-value="uf" autocomplete="new-estado" @click="$event.target.select()" return-object></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <!-- informações gerais -->

            <!-- configurações nfe -->
            <v-tab-item>
              <v-layout row wrap>
                <v-flex xs12 md12>
                  <v-select :items="naturezaOperacoes" item-text="natureza" item-value="id" label="Natureza Operação Padrão" v-model="getEmpresa.natureza_operacao_id" outlined dense class="ml-3 mr-3 mt-1"></v-select>
                </v-flex>
                <v-flex xs12 md6>
                  <v-autocomplete :items="CST" item-text="DESC" item-value="COD" label="CST CSOSN Padrão" v-model="getEmpresa.cst_csosn" outlined dense class="ml-3 mr-3"></v-autocomplete>
                </v-flex>
                <v-flex xs12 md6>
                  <v-autocomplete :items="CSTPisCofins" item-text="DESC" item-value="COD" label="CST PIS Padrão" v-model="getEmpresa.cst_pis" outlined dense class="ml-3 mr-3"></v-autocomplete>
                </v-flex>
                <v-flex xs12 md6>
                  <v-autocomplete :items="CSTPisCofins" item-text="DESC" item-value="COD" label="CST COFINS Padrão" v-model="getEmpresa.cst_confins" outlined dense class="ml-3 mr-3"></v-autocomplete>
                </v-flex>
                <v-flex xs12 md6>
                  <v-autocomplete :items="CSTIpi" item-text="DESC" item-value="COD" label="CST IPI Padrão" v-model="getEmpresa.cst_ipi" outlined dense class="ml-3 mr-3"></v-autocomplete>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select :items="ambenteEmissaoNfe" item-text="tipo" item-value="codigo" label="Ambiente NF-e" v-model="getEmpresa.ambiente_emissao_nfe" class="mr-3 ml-3" outlined dense></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field v-if="getEmpresa.ambiente_emissao_nfe == 1" dense  label="Nº de Série NF-e" v-model="getEmpresa.numero_serie_nfe" class="mr-3 ml-3" outlined></v-text-field>
                  <v-text-field v-else dense label="Nº de Série NF-e" v-model="getEmpresa.numero_serie_nfe_homologacao" class="mr-3 ml-3" outlined></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field v-if="getEmpresa.ambiente_emissao_nfe == 1" dense label="Nº da Última NF-e" v-model="getEmpresa.ultimo_numero_nfe" class="mr-3 ml-3" outlined></v-text-field>
                  <v-text-field v-else dense label="Nº da Última NF-e" v-model="getEmpresa.ultimo_numero_nfe_homologacao" class="mr-3 ml-3" outlined></v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                  <v-select :items="ambenteEmissaoNfe" item-text="tipo" item-value="codigo" label="Ambiente NFC-e" v-model="getEmpresa.ambiente_emissao_nfce" class="mr-3 ml-3" outlined dense></v-select>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field v-if="getEmpresa.ambiente_emissao_nfce == 1" dense label="Nº de Série NFC-e" v-model="getEmpresa.numero_serie_nfce" class="mr-3 ml-3" outlined> </v-text-field>
                  <v-text-field v-else dense label="Nº de Série NFC-e"  v-model="getEmpresa.numero_serie_nfce_homologacao" class="mr-3 ml-3" outlined> </v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field v-if="getEmpresa.ambiente_emissao_nfce == 1" dense label="Nº da Última NFC-e" v-model="getEmpresa.ultimo_numero_nfce" class="mr-3 ml-3" outlined> </v-text-field>
                  <v-text-field v-else dense label="Nº da Última NFC-e" v-model="getEmpresa.ultimo_numero_nfce_homologacao" class="mr-3 ml-3" outlined> </v-text-field>
                </v-flex>
                
                <v-flex xs12 md2>
                  <v-text-field dense label="Código CSC NFC-e" v-model="getEmpresa.csc_nfce" class="mr-3 ml-3" outlined> </v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field dense label="ID CSC NFC-e" v-model="getEmpresa.csc_nfce_id" class="mr-3 ml-3" outlined> </v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field dense label="CFOP Padrão NFC-e" v-model="getEmpresa.cfop_padrao_nfce" class="mr-3 ml-3" v-mask="'#.###'" outlined> </v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-file-input dense label="Certificado Digital" @change="certificadoAnexoChange" class="mr-3 ml-3" counter outlined></v-file-input>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field dense label="Senha do Certificado" v-model="certificadoDigitalSenha" class="mr-3 ml-3" outlined></v-text-field>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <!-- configurações nfe -->

            <!-- natureza operação -->
            <v-tab-item>
              <v-layout row wrap>
                <v-flex xs12 md12> </v-flex>
                <v-flex xs12 md12>
                  <v-btn class="ml-3" outlined color="primary" @click="modalCadastrarNaturezaOperacao = true">Adicionar</v-btn>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Descrição</th>
                          <th class="text-left">CFOP entrada</th>
                          <th class="text-left">CFOP Saída</th>
                          <th class="text-left">CFOP entrada Interestadual</th>
                          <th class="text-left">CFOP Saída Interestadual</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="n in naturezaOperacoes" :key="n.id">
                          <td>{{ n.natureza }}</td>
                          <td>{{ n.cfop_entrada_estadual }}</td>
                          <td>{{ n.cfop_entrada_interestadual }}</td>
                          <td>{{ n.cfop_saida_estadual }}</td>
                          <td>{{ n.cfop_saida_interestadual }}</td>
                          <td>
                            <v-btn outlined color="warning" @click="editarNaturezaOperacao(n.id)">Editar</v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <!-- natureza operação -->

            <!-- tributação -->
            <v-tab-item>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field dense outlined label="ICMS" v-model="getEmpresa.icms" class="ml-3 mr-3 mt-1"> </v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field dense outlined label="PIS" v-model="getEmpresa.pis" class="ml-3 mr-3 mt-1"> </v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field dense outlined label="COFINS" v-model="getEmpresa.cofins" class="ml-3 mr-3"> </v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field dense outlined label="IPI" v-model="getEmpresa.ipi" class="ml-3 mr-3"> </v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-select dense :items="regimes" item-text="regime" item-value="id" label="Regime da Empresa" v-model="getEmpresa.regime" outlined class="ml-3 mr-3"> </v-select>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <!-- tributação -->
          </v-tabs-items>
        </v-flex>
      </v-card-text>

      <v-card-actions>

        <v-btn outlined color="default" @click="$store.dispatch('ativaModalConfirmacao', {
          mensagem: 'Você perderá os dados que já preencheu caso não tenha salvo, deseja realmente voltar?',
          action: 'visualizarPaginaListarEmpresa',
        })">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn outlined color="success" @click="salvar" v-if="this.$helper.verificaPermissao('cadastrar-empresa') || this.$helper.verificaPermissao('atualizar-empresa')">Salvar</v-btn>
        <v-btn outlined class="ml-2" color="primary" @click="salvarCertificado">Salvar Certificado</v-btn>
        <!-- <v-btn v-if="$route.params.id" color="primary" @click="cadastrar">Novo</v-btn> -->
        <!-- <v-btn v-if="$route.params.id" color="error" @click.stop="modalExcluir = true">Excluir</v-btn> -->
        <!-- <v-btn class="white--text" color="blue-grey" @click="$router.push({'name': 'produtos'})">Voltar</v-btn> -->
      </v-card-actions>
    </v-card>

    <v-dialog v-model="modalCadastrarNaturezaOperacao">
      <v-card>
        <v-card-title>Cadastro de Natureza da Operação</v-card-title>
        <form @submit.prevent="salvarNaturezaOperacao">
          <v-card-text>
            <v-layout row wrap>
              <v-flex md12 xs12>
                <v-text-field dense outlined v-model="naturezaOperacao.natureza" label="Nome" :rules="rules.obrigatorio" class="ml-3 mr-3" required></v-text-field>
              </v-flex>
              <v-flex md12 xs12>
                <v-text-field dense outlined v-model="naturezaOperacao.cfop_entrada_estadual" label="CFOP Entrada" :rules="rules.obrigatorio" class="ml-3 mr-3" required> </v-text-field>
              </v-flex>
              <v-flex md12 xs12>
                <v-text-field dense outlined v-model="naturezaOperacao.cfop_entrada_interestadual" label="CFOP Entrada Interestadual" :rules="rules.obrigatorio" class="ml-3 mr-3" required></v-text-field>
              </v-flex>
              <v-flex md12 xs12>
                <v-text-field dense outlined v-model="naturezaOperacao.cfop_saida_estadual" label="CFOP Saída" :rules="rules.obrigatorio" class="ml-3 mr-3" required> </v-text-field>
              </v-flex>
              <v-flex md12 xs12>
                <v-text-field dense outlined v-model="naturezaOperacao.cfop_saida_interestadual" label="CFOP Saída Interstadual" :rules="rules.obrigatorio" class="ml-3 mr-3" required></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined color="default" @click="modalCadastrarNaturezaOperacao = false">Voltar</v-btn>
            <v-spacer></v-spacer>
            <v-btn outlined color="error" @click="modalExcluirNaturezaOperacao = true">Excluir</v-btn>
            <v-btn outlined color="success" type="submit">Salvar</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalExcluirNaturezaOperacao" max-width="400px">
      <v-card>
        <v-card-title>
          <h3>Excluir</h3>
        </v-card-title>
        <v-card-text>
          <h3 align="center">Tem certeza que deseja excluir?</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined color="default" @click="modalExcluirNaturezaOperacao">Voltar</v-btn>
          <v-spacer></v-spacer>
          <v-btn outlined color="error" @click="excluirNaturezaOperacao">SIM</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalLogo" max-width="720">
      <v-card>
        <v-card-title>Logo</v-card-title>
        <v-card-text>
          <v-img :src="getEmpresa.url_logo" v-if="getEmpresa.url_logo" aspect-ratio="1.4" contain></v-img>
          <br />
          <v-file-input dense outlined v-if="showInputLogo" label="logo" @change="selecionaLogo"> </v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-btn color="default" @click="modalLogo = false" outlined>Voltar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="salvarLogo" outlined>Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </LayoutDashboard>
</template>

<script>
import EmpresaService from "@/services/EmpresaService";
import CSTService from "@/services/CSTService";
import NaturezaOperacaoService from "@/services/NaturezaOperacaoService";
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["getEmpresa", "getEstados", "getCidades"]),
  },
  data() {
    return {
      empresa: {
        id: "",
        razao_social: "",
        nome_fantasia: "",
        cnpj: "",
        ie: "",
        cep: "",
        logradouro: "",
        numero: "",
        bairro: "",
        cidade: "",
        uf: "",
        telefone: "",
        celular1: "",
        celular2: "",
        email: "",
        codigo_municipio: "",
        codigo_pais: "",
        pais: 1058,
        cst_csosn: "",
        cst_confins: "",
        cst_pis: "",
        cst_ipi: "",
        frete: "",
        tipo_pagamento: "",
        natureza_operacao_id: "",
        // certificado_arquivo: "",
        // certificado_senha: "",
        ultimo_numero_nfe: "",
        ultimo_numero_nfce: "",
        icms: "",
        pis: "",
        cofins: "",
        ipi: "",
        regime: "",
        logo: null,
      },
      naturezaOperacao: {},
      CST: [],
      CSTPisCofins: [],
      CSTIpi: [],
      regimes: [
        {
          id: "1",
          regime: "Simples Nacional",
        },
        {
          id: "2",
          regime: "Simples Nacional – excesso de sublimite de receita bruta",
        },
        {
          id: "3",
          regime: "Regime Normal",
        },
      ],
      naturezaOperacoes: [],
      modalCadastrarNaturezaOperacao: false,
      modalExcluirNaturezaOperacao: false,
      modalSalvar: false,
      certificadoDigital: "",
      certificadoDigitalSenha: "",
      rules: {
        obrigatorio: [(v) => !!v || "Campo obrigatório."],
      },
      tabs: 0,
      modalLogo: false,
      showInputLogo: true,
      atualizarLogo: false,
      ambenteEmissaoNfe: [
        {
          codigo: 1,
          tipo: "Produção",
        },
        {
          codigo: 2,
          tipo: "Homologação",
        },
      ],
      estadoSelecionado: {},
      cidadeSelecionada: {},
    };
  },
  watch: {
    cidadeSelecionada: function() {
      let indexEstado = this.getEstados.map((i) => i.uf).indexOf(this.cidadeSelecionada.uf);
      this.getEmpresa.codigo_municipio = this.cidadeSelecionada.codigo
      this.estadoSelecionado = this.getEstados[indexEstado];
    },
  },
  methods: {
    ...mapActions(["visualizarEmpresa", "salvarEmpresa", "atualizarEmpresa", "setModalExcluirEmpresa", "listarEstados", "listarCidades"]),
    salvar() {
      this.getEmpresa.cidade = this.cidadeSelecionada.nome;
      this.getEmpresa.codigo_municipio = this.cidadeSelecionada.codigo;
      this.getEmpresa.uf = this.estadoSelecionado.uf;
      this.getEmpresa.codigo_uf = this.estadoSelecionado.codigo_uf;
      this.getEmpresa.codigo_pais = 1058;

      if (this.getEmpresa.id) {
        this.atualizarEmpresa(this.getEmpresa);
      } else {
        this.salvarEmpresa(this.getEmpresa);
      }
    },

    listarCST() {
      CSTService.listarCST()
        .then((res) => {
          this.CST = res.data;
          // console.log('listando CST: ',res.data)
        })
        .catch((e) => console.log(e));

      CSTService.listarCST_PIS_CONFIS()
        .then((res) => (this.CSTPisCofins = res.data))
        .catch((e) => console.log(e));

      CSTService.listarCST_IPI()
        .then((res) => (this.CSTIpi = res.data))
        .catch((e) => console.log(e));
    },

    listarNaturezaOperacoes() {
      this.modalCadastrarNaturezaOperacao = false;
      NaturezaOperacaoService.listar()
        .then((res) => (this.naturezaOperacoes = res.data))
        .catch((e) => console.log(e));
    },

    salvarNaturezaOperacao() {
      this.$store.commit("setOverlay", true);
      this.modalCadastrarNaturezaOperacao = false;
      if (this.naturezaOperacao.id) {
        NaturezaOperacaoService.atualizar(this.naturezaOperacao)
          .then((res) => {
            this.$store.commit("snackbarSuccess", "Natureza da operação atualizada.");
            this.listarNaturezaOperacoes();
            this.naturezaOperacao = {};
            this.$store.commit("setOverlay", false);
          })
          .catch((e) => {
            console.log(e);
            this.$store.commit("setOverlay", false);
            this.$store.commit("snackbarError", "Erro ao atualizar.");
          });
      } else {
        NaturezaOperacaoService.salvar(this.naturezaOperacao)
          .then((res) => {
            this.$store.commit("setOverlay", false);
            this.$store.commit("snackbarSuccess", "Natureza da operação cadastrada com sucesso.");
            this.listarNaturezaOperacoes();
          })
          .catch((e) => {
            console.log(e);
            this.$store.commit("setOverlay", false);
            this.$store.commit("snackbarError", "Erro ao cadastrar.");
          });
      }
    },

    editarNaturezaOperacao(id) {
      this.$store.commit("setOverlay", true);
      NaturezaOperacaoService.editar(id)
        .then((res) => {
          this.$store.commit("setOverlay", false);
          this.naturezaOperacao = res.data;
          this.modalCadastrarNaturezaOperacao = true;
        })
        .catch((e) => console.log(e));
    },

    excluirNaturezaOperacao(id) {
      this.$store.commit("setOverlay", true);

      this.modalCadastrarNaturezaOperacao = false;
      this.modalExcluirNaturezaOperacao = false;
      NaturezaOperacaoService.excluir(this.naturezaOperacao.id)
        .then((res) => {
          this.$store.commit("setOverlay", false);
          this.listarNaturezaOperacoes();
          this.$store.commit("snackbarError", "Registro excluído.");
        })
        .catch((e) => console.log(e));
    },

    pesquisaCep() {
      this.$store.commit("setOverlay", true);

      this.$http
        .get(`https://viacep.com.br/ws/${this.getEmpresa.cep}/json/`)
        .then((res) => {
          this.$store.commit("setOverlay", false);
          this.getEmpresa.logradouro = res.data.logradouro;
          this.getEmpresa.bairro = res.data.bairro;
          this.getEmpresa.cidade = res.data.localidade;
          this.getEmpresa.uf = res.data.uf;
          this.getEmpresa.codigo_municipio = res.data.ibge;
          document.getElementById("numero").focus();
          let indexCidade = this.getCidades.map((i) => i.codigo).indexOf(res.data.ibge);
          this.cidadeSelecionada = this.getCidades[indexCidade];
        })
        .catch((e) => {
          this.$store.commit("setOverlay", false);
          console.log(e);
        });
    },
    certificadoAnexoChange(e) {
      this.certificadoDigital = e;
      console.log("certificado digital", this.certificadoDigital);
    },
    salvarCertificado() {
      this.$store.commit("setOverlay", true);

      let form = new FormData();
      form.append("certificado_arquivo", this.certificadoDigital);
      form.append("certificado_senha", this.certificadoDigitalSenha);

      EmpresaService.uploadCertificado(form)
        .then((res) => {
          this.$store.commit("setOverlay", false);
          this.$store.commit("snackbarSuccess", "Certificado salvo.");
        })
        .catch((e) => {
          console.log(e);
          this.$store.commit("setOverlay", false);
          this.$store.commit("snackbarError", "Erro ao salvar certificado.");
        });
    },
    selecionaLogo(e) {
      this.getEmpresa.logo = e;
      this.atualizarLogo = true;
    },
    salvarLogo(e) {
      let form = new FormData();
      form.append("logo", this.getEmpresa.logo);
      EmpresaService.salvarLogo(form, this.getEmpresa.id)
        .then((res) => {
          this.$store.commit("setEmpresa", { ...this.getEmpresa, url_logo: res.data.url_logo });
          this.showInputLogo = false;
          this.$nextTick(() => {
            this.showInputLogo = true;
          });
          this.atualizaLogo = false;
        })
        .catch((e) => console.log(e));
    },
    voltar(){
      confirm('Você perderá os dados que já preencheu caso não tenha salvo, deseja realmente voltar?',
        this.$router.push({name: 'empresas'})
      )
    }
  },
  mounted() {
    this.listarNaturezaOperacoes();
    this.listarCST();
    if (this.$route.params.id) {
      this.visualizarEmpresa(this.$route.params.id)
      .then(() => {
        let indexCidade = this.getCidades.map((i) => i.codigo).indexOf(this.getEmpresa.codigo_municipio);
          this.cidadeSelecionada = this.getCidades[indexCidade];
      });
    }
  },
  created() {
    this.listarEstados();
    this.listarCidades().then((res) => {
      let indexCidade = this.getCidades.map((i) => i.codigo).indexOf(this.getEmpresa.codigo_municipio);
      this.cidadeSelecionada = this.getCidades[indexCidade];
    });
  },
};
</script>
